import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearError,
  getAllCompanies,
  resetResponseState,
  selectAllCompanies,
  selectError,
  selectLoading,
} from "../../redux/company/companySlice";
import CompanyForm from "./CompanyFrom";
import { Link } from "react-router-dom";
import { selectAdmin } from "../../redux/admin/adminSlice";
import CompanyEditModal from "./CompanyEditModel";
import Papa from "papaparse";
import { getDataInCsv } from "../../utils/api/submissions";
import { Icon } from "@iconify-icon/react/dist/iconify.mjs";
import EmployeeForm from "../employeeForm/EmployeeForm";
import { toast, ToastContainer } from "react-toastify";
import { deleteCompany, disableCompany } from "../../utils/api/company";
import PopConfirm from "./PopConfirm";
import DisableCompanyPopup from "./DisableCompanyPop";
import ShowCompanyForm from "./ShowCompanyForm";
import Title from "../custom-components/Title/Title";
import Search from "../custom-components/Search/Search";
import Button from "../custom-components/Button/Button";
import CustomModal from "../custom-components/custom-modal/CustomModal";
import Loader from "../custom-components/Loader/Loader";
import CompanyEmployee from "../modals/company-employee/CompanyEmployee";
import CompanySupervisor from "../modals/company-supervisor/CompanySupervisor";
import CompanyResponse from "../modals/company-response/CompanyResponse";
import UploadFileDialog from "./FileUploadDialog";

function Company() {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const error = useSelector(selectError);
  const allCompanies = useSelector(selectAllCompanies);
  const admin = useSelector(selectAdmin);
  const [openModal, setOpenModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showFormModal, setShowFormModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 20;
  const [refresh, setRefresh] = useState(false);
  const [show, setShow] = useState(false);
  const [openEmployeeForm, setOpenEmployeeForm] = useState(false);
  const [openEmployeeComp, setOpenEmployeeComp] = useState(false);
  const [openSupervisor, setOpenSupervisor] = useState(false);
  const [openResponse, setOpenResponse] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [disConfirmPopup, setDisConfirmPopup] = useState(false);
  const [showFileUploadDialog, setShowFileUploadDialog] = useState(false);

  const handleEditClick = (company) => {
    setSelectedCompany(company);
    setOpenModal(true);
  };

  const handleFormViewClick = (company) => {
    setSelectedCompany(company);
    setShowFormModal(true);
  };

  const handleUserViewClick = (company) => {
    setSelectedCompany(company);
    setOpenEmployeeForm(true);
  };

  const handleEmployeeViewClick = (company) => {
    setSelectedCompany(company);
    setOpenEmployeeComp(true);
  };

  const handleSupervisorsViewClick = (company) => {
    setSelectedCompany(company);
    setOpenSupervisor(true);
  };
  const handleResponseViewClick = (company) => {
    setSelectedCompany(company);
    setOpenResponse(true);
  };

  const handleRefreshClick = () => {
    setSearchTerm("");
    dispatch(getAllCompanies());
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  async function downloadCsv() {
    try {
      const csvData = currentCompanies?.map((company) => ({
        "Client Id": company.id || "",
        "Client Name": company.name || "",
        "Client Email": company.email || "",
        "API Username": company.apiUsername || "",
        "API Password": company.apiPassword || "",
        "Form Link": company.formLink || "",
        "No. of Submission": company.totalFormSubmissions || "",
      }));

      const csv = Papa.unparse(csvData, {
        header: true,
      });

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute("download", "companies.csv");

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } catch (error) {
      // console.error("Error downloading CSV: ", error);
    }
  }

  const handleCompanyDisable = async (company) => {
    try {
      await disableCompany(company.id);
      toast.success(
        `Company ${company.isActive == true ? "Disabled" : "Enabled"}!`
      );
      setRefresh(!refresh);
      return;
    } catch (err) {
      console.log(err);
      toast.error("Something Went Wrong!");
    }
  };

  useEffect(() => {
    dispatch(resetResponseState());
    dispatch(getAllCompanies());
  }, [dispatch, refresh]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const filteredCompanies = useMemo(() => {
    if (!searchTerm) return allCompanies || [];
    return allCompanies.filter(
      (company) =>
        company.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        company.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        company.id.includes(searchTerm)
    );
  }, [searchTerm, allCompanies]);

  const totalPages = Math.ceil(filteredCompanies.length / recordsPerPage);

  const currentCompanies = useMemo(() => {
    const startIndex = (currentPage - 1) * recordsPerPage;
    return filteredCompanies.slice(startIndex, startIndex + recordsPerPage);
  }, [filteredCompanies, currentPage]);

  const handlePageChange = (direction) => {
    if (direction === "next" && currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    } else if (direction === "prev" && currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleCompanyDelete = async (company) => {
    try {
      await deleteCompany(company.id);
      toast.success("Company Deleted!");
      dispatch(getAllCompanies());
    } catch (err) {
      // console.log(err);
      toast.error("Something Went Wrong!");
    }
  };

  // const downloadCsv = () => {
  //   const csvData = currentCompanies.map((company) => ({
  //     "Client Id": company.id || "",
  //     "Client Name": company.name || "",
  //     "Client Email": company.email || "",
  //     "API Username": company.apiUsername || "",
  //     "API Password": company.apiPassword || "",
  //     "Form Link": company.formLink || "",
  //     "No. of Submission": company.totalFormSubmissions || "",
  //   }));

  //   const csv = Papa.unparse(csvData, { header: true });
  //   const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  //   const link = document.createElement("a");
  //   const url = URL.createObjectURL(blob);
  //   link.href = url;
  //   link.setAttribute("download", "companies.csv");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  useEffect(() => {
    dispatch(resetResponseState());
    dispatch(getAllCompanies());
  }, [dispatch]);

  return (
    <div>
      <ToastContainer></ToastContainer>
      <Title text="All Companies" />
      <div className="m-10 flex flex-wrap justify-between">
        <div className="w-full md:w-[60%] mb-4 md:mb-0 bg-[#FFF]/10">
          <Search
            placeholder="Search by name, email, or id"
            handleSearchInputChange={(e) => setSearchTerm(e.target.value)}
            searchQuery={searchTerm}
          />
        </div>

        <div className="w-full md:w-[40%] flex flex-wrap justify-between items-center space-x-4">
          <div
            onClick={handleRefreshClick}
            className="flex justify-end bg-[#FFF]/10 border-[1px] border-gray-600 rounded-lg px-6 py-2 cursor-pointer w-full sm:w-auto"
          >
            <div className="flex items-center space-x-3">
              <h1 className="text-normal flex text-center items-center">
                Refresh
              </h1>
              <div className="text-blue-950 flex items-center justify-center">
                <Icon icon="uil:refresh" width="1.2em" height="1.2em" />
              </div>
            </div>
          </div>

          {admin && admin.role !== "administrator" && (
            <button
              onClick={downloadCsv}
              className="px-10 py-2 mx-2 ml-6 font-semibold text-center text-white bg-green-600 rounded-lg cursor-pointer"
            >
              Export CSV
            </button>
          )}
          {admin && admin.role === "administrator" && (
            <Button
              text="Create Company"
              handleClick={() => setShow(true)}
              className="w-full sm:w-auto"
            />
          )}
        </div>
      </div>
      {!loading ? (
        <div className="m-5">
          {error && error.message ? (
            <div className="text-red-500">{error.message}</div>
          ) : filteredCompanies?.length === 0 ? (
            <p>No companies exists</p>
          ) : (
            <div>
              <div className="overflow-x-auto mx-6 font-normal">
                <table className=" border border-collapse border-gray-300 shadow-lg table-auto ">
                  <thead className="sticky top-0">
                    <tr className="bg-gray-200">
                      <th className="px-4 py-2 border border-gray-300">
                        Client Id
                      </th>
                      <th className="px-4 py-2 border border-gray-300">
                        Client Name
                      </th>
                      <th className="px-4 py-2 border border-gray-300">
                        Client Email
                      </th>
                      <th className="px-4 py-2 border border-gray-300">
                        API Username
                      </th>
                      <th className="px-4 py-2 border border-gray-300">
                        API Password
                      </th>
                      <th className="px-4 py-2 border border-gray-300">
                        Form Link
                      </th>
                      <th className="px-4 py-2 border border-gray-300">Form</th>
                      <th className="px-4 py-2 border border-gray-300">
                        Create User
                      </th>
                      <th className="px-4 py-2 border border-gray-300">
                        No. of Submission{" "}
                      </th>
                      <th className="px-1 py-2 border border-gray-300">
                        Employees
                      </th>
                      <th className="px-1 py-2 border border-gray-300">
                        Supervisors
                      </th>
                      <th className="px-1 py-2 border border-gray-300">
                        Responses
                      </th>

                      {admin && admin.role === "administrator" && (
                        <th className="px-4 py-2 border border-gray-300">
                          Actions
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody className="">
                    {currentCompanies.length > 0 ? (
                      currentCompanies.map((company) => (
                        <tr key={company.id} className="hover:bg-gray-100">
                          <td className="px-4 py-2 border border-gray-300">
                            {company.id}
                          </td>
                          <td className="px-4 py-2 border border-gray-300">
                            {company.name}
                          </td>
                          <td className="px-4 py-2 border border-gray-300">
                            {company.email}
                          </td>
                          <td className="px-4 py-2 border border-gray-300">
                            {company.apiUsername}
                          </td>
                          <td className="px-4 py-2 border border-gray-300">
                            {company.apiPassword}
                          </td>
                          <td className="px-4 py-2 border border-gray-300">
                            <p className="text-blue-500 ">{company.formLink}</p>
                          </td>
                          <td className="px-4 py-2 text-center border">
                            <button
                              onClick={() => handleFormViewClick(company)}
                              className="px-2 py-[6px] w-full text-white text-center transition duration-300 bg-green-700 rounded hover:bg-green-600"
                            >
                              View
                            </button>
                          </td>
                          <td className="px-4 py-2 text-center border">
                            <button
                              onClick={() => handleUserViewClick(company)}
                              className="px-2 py-[6px] w-full text-white text-center transition duration-300 bg-green-700 rounded hover:bg-green-600"
                            >
                              View
                            </button>
                          </td>
                          <td className="px-2 py-2 text-center border border-gray-300">
                            <p className="text-blue-500 ">
                              {company.totalFormSubmissions}
                            </p>
                          </td>
                          <td className="p-2 text-center border">
                            <button
                              onClick={() => handleEmployeeViewClick(company)}
                              className="px-4 py-[6px] w-full text-white text-center transition duration-300 bg-blue-700 rounded hover:bg-blue-600"
                            >
                              View
                            </button>
                          </td>
                          <td className="p-2 text-center border">
                            <button
                              onClick={() =>
                                handleSupervisorsViewClick(company)
                              }
                              className="px-4 py-[6px] w-full text-white text-center transition duration-300 bg-blue-700 rounded hover:bg-blue-600"
                            >
                              View
                            </button>
                          </td>
                          <td className="p-2 text-center border">
                            <button
                              onClick={() => handleResponseViewClick(company)}
                              className="px-4 py-[6px] w-full text-white text-center transition duration-300 bg-blue-700 rounded hover:bg-blue-600"
                            >
                              View
                            </button>
                          </td>
                          {admin && admin.role === "administrator" && (
                            <td className="p-2 text-center border-b">
                              <div className="flex justify-between">
                                <Icon
                                  onClick={() => {
                                    setSelectedCompany(company);
                                    setDisConfirmPopup(true);
                                  }}
                                  className={`text-lg ${
                                    company.isActive
                                      ? "text-green-600"
                                      : "text-red-600"
                                  } cursor-pointer`}
                                  icon="ic:sharp-disabled-visible"
                                />
                                <Icon
                                  onClick={() => handleEditClick(company)}
                                  className="text-lg text-blue-700 cursor-pointer"
                                  icon="fluent:clipboard-text-edit-48-regular"
                                />
                                <Icon
                                  onClick={() => {
                                    setSelectedCompany(company);
                                    setConfirmPopup(true);
                                  }}
                                  className="text-lg text-gray-700 cursor-pointer"
                                  icon="mingcute:delete-2-fill"
                                />
                                <button
                                  onClick={() => {
                                    setSelectedCompany(company);
                                    setShowFileUploadDialog(true);
                                  }}
                                  className="px-2 py-1 text-white bg-blue-500 rounded hover:bg-blue-600"
                                >
                                  Upload File
                                </button>
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="8"
                          className="p-4 text-center text-gray-500"
                        >
                          No companies found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="my-28">
          <Loader size={"w-24 h-24"} />
        </div>
      )}

      <div className="flex justify-center mt-4">
        <button
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          className="px-4 py-2 text-white rounded bg-gray-950 disabled:opacity-50"
        >
          Previous
        </button>

        <span className="px-4 py-2">
          Page {currentPage} of {totalPages}
        </span>

        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          className="px-4 py-2 text-white rounded bg-gray-950 disabled:opacity-50"
        >
          Next
        </button>
      </div>
      {openModal && selectedCompany && (
        <CompanyEditModal
          admin={selectedCompany}
          setRefresh={setRefresh}
          closeModal={setOpenModal}
        />
      )}
      {confirmPopup && (
        <PopConfirm
          closePopup={setConfirmPopup}
          confirm={handleCompanyDelete}
          item={selectedCompany}
        />
      )}
      {disConfirmPopup && (
        <DisableCompanyPopup
          closePopup={setDisConfirmPopup}
          confirm={handleCompanyDisable}
          item={selectedCompany}
        />
      )}
      <CustomModal isOpen={show} closeModal={() => setShow(false)}>
        <CompanyForm setShow={setShow} setRefresh={setRefresh} />
      </CustomModal>
      <CustomModal
        isOpen={showFormModal}
        closeModal={() => setShowFormModal(false)}
      >
        <ShowCompanyForm
          company={selectedCompany}
          closeModal={() => setShowFormModal(false)}
        />
      </CustomModal>

      <CustomModal
        isOpen={openEmployeeForm}
        closeModal={() => setOpenEmployeeForm(false)}
      >
        <EmployeeForm
          company={selectedCompany}
          setRefresh={setRefresh}
          closeModal={() => setOpenEmployeeForm(false)}
        />
      </CustomModal>
      <CustomModal
        isOpen={openEmployeeComp}
        closeModal={() => setOpenEmployeeComp(false)}
      >
        <CompanyEmployee
        setRefresh={setRefresh}
        companyId={selectedCompany?.id} />
      </CustomModal>

      <CustomModal
        isOpen={openSupervisor}
        closeModal={() => setOpenSupervisor(false)}
      >
        <CompanySupervisor
        setRefresh={setRefresh}
        companyId={selectedCompany?.id} />
      </CustomModal>

      <CustomModal
        isOpen={openResponse}
        closeModal={() => setOpenResponse(false)}
      >
        <CompanyResponse companyId={selectedCompany?.id} />
      </CustomModal>

      {showFileUploadDialog && selectedCompany && (
        <CustomModal isOpen={showFileUploadDialog} closeModal={() => setShowFileUploadDialog(false)}>
          <UploadFileDialog
            confirm={(file) => {
              console.log("File uploaded:", file);
              setShowFileUploadDialog(false);
            }}
            item={selectedCompany}
            closePopup={setShowFileUploadDialog}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default Company;
